import { getDeviceList } from '../../../store/slice/health-monitor/device-list';
import store from '../../../store/store';

export const loadDevices = async () => {
  return await store.dispatch(getDeviceList());
};
